module.exports = __webpack_public_path__ + "static/media/m_beard_medium_diamond__v_1.252dfd59.png";